export const tags = ['city',
    'street',
    'traffic',
    'capital',
    'urban',
    'animal',
    'wind',
    'water',
    'weather',
    'announces',
    'loud',
    'quiet',
    'noisy',
    'artificial',
    'melodic',
    'funny',
    'rare',
    'nature',
    'strange',
    'voices',
    'atmospheric',
    'high pitched',
    'echo',
    'deep',
    'pure']
